module.exports = __webpack_public_path__ + "static/footer02-934faab958b12d11e601b84b75601d2c.png";